import { trackLike } from '../tracking/track-like';
export const useOptimisticReactionsUpdate = (propChannel = '', urn = '', inputHintClick = false) => {
    const handleOnComplete = (data) => {
        var _a, _b, _c, _d, _e, _f;
        const like = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.socialCreateReaction) === null || _a === void 0 ? void 0 : _a.success) === null || _b === void 0 ? void 0 : _b.interactionTarget) !== null && _c !== void 0 ? _c : undefined;
        const unlike = (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.socialDeleteReaction) === null || _d === void 0 ? void 0 : _d.success) === null || _e === void 0 ? void 0 : _e.interactionTarget) !== null && _f !== void 0 ? _f : undefined;
        like && trackLike({ hasLike: true, urn, propChannel, inputHintClick });
        unlike && trackLike({ hasLike: false, urn, propChannel, inputHintClick });
    };
    return { handleOnComplete };
};
//# sourceMappingURL=use-optimistic-reactions-update.js.map